/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Player_SuspendedInputs */



/**
* | output |
* | --- |
* | "Player is suspended and cannot participate" |
*
* @param {Err_Tournament_Player_SuspendedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_suspended = /** @type {((inputs?: Err_Tournament_Player_SuspendedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_SuspendedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le joueur est suspendu et ne peut pas participer")
	if (locale === "es") return /** @type {LocalizedString} */ ("El jugador está suspendido y no puede participar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O jogador está suspenso e não pode participar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il giocatore è sospeso e non può partecipare")
	return /** @type {LocalizedString} */ ("Player is suspended and cannot participate")
});